import $ from 'jquery';

export default function run(selector,  cb){
  $(function(){
    const el = $(selector);
    if(el.length){
      cb(el);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utilities/run/index.js